import React from 'react';
import styles from './ServicesTitle.module.css';

interface ServicesTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const ServicesTitle: React.FC<ServicesTitleProps> = ({
  children,
  className,
}) => {
  return (
    <h2 className={`${styles.servicesTitle} ${className || ''}`}>{children}</h2>
  );
};
